export type Locale = 'cs' | 'en';

export const LOCALES: { value: Locale; label: string; short: string }[] = [
    { value: 'cs', label: 'Čeština', short: 'CZ' },
    { value: 'en', label: 'English', short: 'EN' },
];

export const DEFAULT_LOCALE: Locale = 'cs';

export const LOCALE_STORAGE_KEY = '_admin_locale';
